export default {
  en: {
    i18n: {
      langShort: 'en',
      langLong: 'English',
      english: 'English',
      czech: 'Česky',
    },
    loginPage: {
      title: 'Login',
      message: 'Welcome back, please login to your account.',
      email: 'Email',
      password: 'Password',
      forgotPasswordBtn: 'Forgot password?',
      registerBtn: 'Register',
      loginBtn: 'Login',
      emptyErr: 'Please fill both username and password to sign in!',
      invalidErr: 'The username or password is incorrect!',
      invalidFormatErr: 'Password or username has incorrect format or is empty!',
    },
    registerPage: {
      title: 'Create new account',
      fullname: 'Full name',
      companyName: 'Company name',
      email: 'Email',
      password: 'Password',
      passwordAgain: 'Password again',
      alreadyRegistered: 'Already registered?',
      signInBtn: 'Sign in',
      submitBtn: 'Submit',
      registrationSuccessful: 'Registration successful',
      passwordRequiredErr: 'Password is required',
      nameRequiredErr: 'Name is required',
      companyNameRequiredErr: 'Company name is required',
      differentPasswordsErr: 'Passwords must match',
      weakPasswordErr:
        'Password must contain at least one letter and one number and be at least 8 characters long',
      invalidEmailErr: 'Invalid email format',
      welcomeToCashCapMsg: 'Welcome to CashCap!',
    },
    forgottenPasswordPage: {
      title: 'Forgotten password',
      message: 'Please fill out your email, where we will send you a password renewal link.',
      email: 'Email',
      signIn: 'Sign in',
      invalidEmailErr: 'Please enter a valid email',
      resetEmailSentMsg: 'An email with a reset password link has been sent to your email address',
    },
    resetPasswordPage: {
      title: 'Reset your password',
      password: 'Password',
      passwordAgain: 'Password again',
      signIn: 'Sign in',
      emptyFieldErr: 'You must fill both fields',
      differentPasswordsErr: 'Passwords must match',
      weakPasswordErr:
        'Password must contain at least one letter and one number and be at least 8 characters long',
      passwordChangedMsg: 'Your password has been successfully changed',
    },
    common: {
      submit: 'Submit',
      fixErrors: 'Please correct the following errors:',
      multiselectFilter: {
        label: ({ values: { selected, total } }) => `Selected ${selected} / ${total}`,
        selectAll: 'Select all',
        selectNo: 'Deselect all',
      },
    },
    leftMenu: {
      home: 'Home',
      settings: 'Settings',
    },
    topMenu: {
      changeInfo: 'Change profile info',
      changePassword: 'Change password',
      logout: 'Logout',
      name: 'Name',
      email: 'Email',
      currentPassword: 'Current password',
      newPassword: 'New password',
      saveBtn: 'Save',
      shortNameErr: 'Your name should be at least 4 characters long',
      invalidEmailErr: 'The email format is invalid',
      currentPasswordRequiredErr: 'Your current password is required',
      newPasswordRequiredErr: 'New password is required',
      differentPasswordErr: 'New password must be different from old one',
      weakPasswordErr:
        'Password must contain at least one letter and one number and be at least 8 characters long',
      invalidCurrentPassword: 'Given current password is invalid',
      passwordChangedMsg: 'Password changed successfully',
      infoChangedMsg: 'Information has been changed',
    },
    bottomMenu: {
      backToTop: 'Back to top',
    },
    homePage: {
      welcome: 'Welcome back, {userName}.',
      managedCompanies: ({ values: { numberOfProjects } }) => {
        return `You manage ${numberOfProjects} ${numberOfProjects === 1 ? 'company' : 'companies'}.`;
      },
      cashFlow: 'Cash Flow',
      capacities: 'Capacities',
      people: 'People',
      projects: 'Projects',
      timesheet: 'Timesheet',
      workReports: 'Work Reports',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create new company',
      createCompanyDialog: {
        createTitle: 'Create new Company',
        editTitle: 'Edit Company',
        namePlaceholder: 'COMPANY NAME',
        balancePlaceholder: 'INITIAL BALANCE',
        balanceTooltip:
          'Initial ballance is a starting point for your cashflow management in cashcap. If you start from scratch, leave a 0. If you are already working on a project or company, put in the amount of cash availible on your bank account by the end of last month.',
        createBtn: 'Create',
        editBtn: 'Save changes',
      },
      deleteCompanyDialog: {
        title: 'Do you want to delete?',
        deleteBtn: 'Delete',
      },
    },
    settingsPage: {
      title: 'Settings for {companyName}',
      inviteHeader: 'Invite user',
      userEmail: 'User email',
      inviteBtn: 'Invite',
      invitationEmailRequiredErr: 'Email is required',
      invitationEmailInvalidErr: 'Please enter a valid email format',
      invitationSentMsg: 'Invitation has been sent',
      userSettingsHeader: 'Users settings',
      nameEmailRoleColumn: 'Name, Email, Role',
      assignedProjectsColumn: 'Assigned Projects',
      employeesColumn: 'People',
      resetPasswordDeleteUserLabel: 'Reset password, Delete user',
      roleLabel: 'Role',
      saveBtn: 'Save',
      allProjects: 'All projects',
      allEmployees: 'All people',
      assignedEmployees: 'Assigned people to fill',
      favoriteEmployee: 'Favorite person',
      noAssignedEmployees: '(none)',
      noFavoriteEmployee: '(none)',
      setFavoriteEmployeeBtn: 'Set',
      assignProjectBtn: 'Assign',
      unassignProjectBtn: 'Unassign',
      assignEmployeeBtn: 'Assign',
      resetBtn: 'Reset',
      deleteBtn: 'Delete',
    },
    cashFlowPage: {
      title: '{projectName}: Finance',
      companyOverview: 'Company overview',
      previousMonth: 'Previous month',
      nextMonth: 'Next month',
      showDeletedItems: 'Show deleted items',
      showHiddenItems: 'Show hidden items',
      hideDeletedItems: 'Hide deleted items',
      hideItems: 'Hide items',
      months: {
        '01': 'January',
        '02': 'February',
        '03': 'March',
        '04': 'April',
        '05': 'May',
        '06': 'June',
        '07': 'July',
        '08': 'August',
        '09': 'September',
        '10': 'October',
        '11': 'November',
        '12': 'December',
      },
      categories: {
        'saldo-cumulative': 'Cumulative Balance',
        'saldo-forecast-cumulative': 'Cumulative Forecasted Balance',
        'forecast-cumulative': 'Cumulative Forecast',
        forecast: 'Forecast',
        'saldo-internal': 'Internal Projects Balance',
        saldo: 'Balance',
        income: 'Incomes',
        expense: 'Expenses',
        'vat-estimate': 'VAT estimate',
        'vat-reality': 'VAT reality',
        1: 'Expenses',
        2: 'Incomes',
        3: 'Forecast Expenses',
        4: 'Forecast Incomes',
        5: 'People',
        6: 'Internal Projects',
      },
      defaultCapacityDialog: {
        title({ values: { employee } }) {
          return `Default capacity${employee ? ' for ' + employee.name : ''}`;
        },
        submitBtn: 'Submit',
      },
      vatSelectDialog: {
        editTitle: 'Edit VAT rates',
        selectTitle: 'Select VAT rate',
        noneLabel: 'None',
      },
      aggregation: {
        sum: 'Sum',
        average: 'Average',
        min: 'Minimum',
        max: 'Maximum',
        count: 'Count',
      },
    },
    capacitiesPage: {
      title: '{projectName}: Capacities',
      weekTitle: 'Week {weekNumber}',
      projectsHeader: 'Projects',
      previousWeek: 'Previous week',
      nextWeek: 'Next week',
      employee: 'Person',
      capacity: 'Capacity',
      utilization: 'Utilization',
      workingHours: 'Availible capacity',
      plan: 'Plan',
      fact: 'Fact',
      addNewEmployee: 'Add new person',
      addNewProject: 'Add new project',
      assignInternalProject: 'Assign Internal Project',
      showDeletedItems: 'Show deleted items',
      showHiddenItems: 'Show hidden items',
      hideDeletedItems: 'Hide deleted items',
      hideItems: 'Hide items',
    },
    employeesPage: {
      title: '{projectName}: People',
      employeesHeader: 'People',
      addNewEmployee: 'Add new person',
      previousWeek: 'Previous week',
      nextWeek: 'Next week',
      weeksLabel: 'Week {start} - {end}',
      weekTitle: 'Week {weekNumber}',
      plan: 'Plan',
      fact: 'Fact',
      capacity: 'Cap',
      noAssignedProjects: 'This person does not have any projects assigned.',
      assignProject: 'Assign Project',
      assignProjectTo: 'Assign project to {employeeName}',
    },
    projectsPage: {
      title: '{projectName}: Projects',
      projectsHeader: 'Projects',
      addNewProject: 'Add new project',
      previousWeek: 'Previous week',
      nextWeek: 'Next week',
      weeksLabel: 'Week {start} - {end}',
      weekTitle: 'Week {weekNumber}',
      plan: 'Plan',
      fact: 'Fact',
    },
    timesheetsPage: {
      title: '{projectName}: Timesheet',
      selectPerson: 'Select person',
      weekTitle: 'Week {weekNumber}',
      projectsHeader: 'Projects',
      previousWeek: 'Previous week',
      nextWeek: 'Next week',
      'calculated-plan': 'Plan',
      'calculated-fact': 'Fact',
      'calculated-capacity': 'Capacity',
      'calculated-onload': 'Onload',
      assignProject: 'Assign Project',
      showHiddenItems: 'Show hidden items',
      hideItems: 'Hide items',
      columnHeader: ({ values: { columnId } }) => {
        if (columnId === 'total-plan') {
          return 'TOTAL PLÁN';
        }
        if (columnId === 'total-fact') {
          return 'TOTAL REALITA';
        }
        const date = new Date(columnId);
        const [, m, d] = columnId.split('-');
        const dayNum = date.getDay();
        const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return `${days[dayNum]} ${d}. ${m}.`;
      },
    },
    workReportsPage: {
      title: '{projectName}: Work Reports',
      workReportsHeader: 'Work Reports',
      projectColumn: 'Project',
      employeeColumn: 'Employee',
      dateColumn: 'Date',
      invoiceColumn: 'Invoice',
      noteColumn: 'Note',
      hoursColumn: 'Hours',
      yesNoBoolean: {
        1: 'Yes',
        0: 'No',
        null: '-',
      },
      csvExportBtn: 'CSV Export',
      saveRow: 'Save',
      discardRow: 'Discard changes',
      resetRow: 'Reset',
      deleteNewRow: 'Delete',
      newWorkReport: 'New Work Report',
      itemsPerPage: 'Rows per page',
      forceUpdateDialog: {
        title:
          'A work report for the given employee, project and day with a filled time, note or invoice already exists. Do you want to overwrite it?',
        overwriteBtn: 'Overwrite',
        cancelBtn: 'Cancel',
      },
      assignProject: 'Assign Project',
    },
  },
  cs: {
    i18n: {
      langShort: 'cs',
      langLong: 'Česky',
      english: 'English',
      czech: 'Česky',
    },
    loginPage: {
      title: 'Login',
      message: 'Vítejte zpět, prosím přihlašte se ke svému účtu.',
      email: 'Email',
      password: 'Heslo',
      forgotPasswordBtn: 'Zapomenuté heslo?',
      registerBtn: 'Registrovat',
      loginBtn: 'Přihlásit se',
      emptyErr: 'Prosím vyplňte uživatelské jméno a heslo pro přihlášení!',
      invalidErr: 'Uživatelské jméno nebo heslo je nesprávné!',
      invalidFormatErr: 'Uživatelské jméno nebo heslo má nesprávný formát!',
    },
    registerPage: {
      title: 'Vytvořit nový účet',
      fullname: 'Celé jméno',
      companyName: 'Název společnosti',
      email: 'Email',
      password: 'Heslo',
      passwordAgain: 'Heslo znovu',
      alreadyRegistered: 'Už máte účet?',
      signInBtn: 'Přihlásit se',
      submitBtn: 'Registrovat',
      registrationSuccessful: 'Úspěšná registrace',
      passwordRequiredErr: 'Heslo je vyžadováno',
      nameRequiredErr: 'Jméno je vyžadováno',
      companyNameRequiredErr: 'Název společnosti je vyžadován',
      differentPasswordsErr: 'Hesla se musí shodovat',
      weakPasswordErr:
        'Heslo musí obsahovat alespoň jedno písmeno, jednu číslici a být minimálně 8 znaků dlouhé',
      invalidEmailErr: 'Chybný formát emailu',
      welcomeToCashCapMsg: 'Vítejte v CashCap!',
    },
    forgottenPasswordPage: {
      title: 'Zapomenuté heslo',
      message: 'Prosím vyplňte email, kam Vám přijde odkaz pro obnovu heslo.',
      email: 'Email',
      signIn: 'Přihlásit se',
      invalidEmailErr: 'Prosím vyplňte validní email',
      resetEmailSentMsg: 'Email s odkazem pro obnovu hesla byl odeslán na Váš email',
    },
    resetPasswordPage: {
      title: 'Resetujte Vaše heslo',
      password: 'Heslo',
      passwordAgain: 'Heslo znovu',
      signIn: 'Přihlásit se',
      emptyFieldErr: 'Musíte vyplnit obě pole',
      differentPasswordsErr: 'Hesla se muís shodovat',
      weakPasswordErr:
        'Heslo musí obsahovat alespoň jedno písmeno, jednu číslici a být minimálně 8 znaků dlouhé',
      passwordChangedMsg: 'Vaše heslo bylo úspěšně změněno',
    },
    common: {
      submit: 'Odeslat',
      fixErrors: 'Prosím opravte následující chyby:',
      multiselectFilter: {
        label: ({ values: { selected, total } }) => `Vybráno ${selected} / ${total}`,
        selectAll: 'Vybrat vše',
        selectNo: 'Zrušit vše',
      },
    },
    leftMenu: {
      home: 'Domů',
      settings: 'Nastavení',
    },
    topMenu: {
      changeInfo: 'Upravit profil',
      changePassword: 'Změnit heslo',
      logout: 'Odhlásit se',
      name: 'Jméno',
      email: 'Email',
      currentPassword: 'Stávající heslo',
      newPassword: 'Nové heslo',
      saveBtn: 'Uložit',
      shortNameErr: 'Vaše uživatelské jméno musí být alespoň 4 znaky dlouhé',
      invalidEmailErr: 'Formát emailu je chybný',
      currentPasswordRequiredErr: 'Stávající heslo je vyžadováno',
      newPasswordRequiredErr: 'Nové heslo je vyžadováno',
      differentPasswordErr: 'Nové heslo musí být rozdílné od stávajícího',
      weakPasswordErr:
        'Heslo musí obsahovat alespoň jedno písmeno, jednu číslici a být minimálně 8 znaků dlouhé',
      invalidCurrentPassword: 'Zadané stávající heslo je nespávné',
      passwordChangedMsg: 'Heslo bylo úspěšně změněno',
      infoChangedMsg: 'Informace byly změněny',
    },
    bottomMenu: {
      backToTop: 'Zpět nahoru',
    },
    homePage: {
      welcome: 'Vítejte zpět, {userName}.',
      managedCompanies: ({ values: { numberOfProjects } }) => {
        const projectSpelling = {
          1: 'společnost',
          2: 'společnosti',
          3: 'společnosti',
          4: 'společnosti',
          other: 'společností',
        };
        return `Spravujete ${numberOfProjects} ${projectSpelling[numberOfProjects] || projectSpelling.other}.`;
      },
      cashFlow: 'Cash Flow',
      capacities: 'Kapacity',
      people: 'Lidé',
      projects: 'Projekty',
      timesheet: 'Timesheet',
      workReports: 'Výkazy práce',
      delete: 'Smazat',
      edit: 'Upravit',
      create: 'Vytvořit novou společnost',
      createCompanyDialog: {
        createTitle: 'Vytvořit novou společnost',
        editTitle: 'Upravit společnost',
        namePlaceholder: 'NÁZEV SPOLEČNOSTI',
        balancePlaceholder: 'POČÁTEČNÍ BILANCE',
        balanceTooltip:
          'Počáteční bilance je startovní bod vaší cashflow v cashcap. Pokud začínáte od nuly, nechte ji nulovou. Pokud na projektu nebo společnosti už pracujete, zadejte zůstatek na účtu na konci minulého měsíce.',
        createBtn: 'Vytvořit',
        editBtn: 'Uložit změny',
      },
      deleteCompanyDialog: {
        title: 'Chcete smazat?',
        deleteBtn: 'Smazat',
      },
    },
    settingsPage: {
      title: 'Nastavení pro {companyName}',
      inviteHeader: 'Pozvat uživatele',
      userEmail: 'Uživateský email',
      inviteBtn: 'Pozvat',
      invitationEmailRequiredErr: 'Email je vyžadován',
      invitationEmailInvalidErr: 'Prosím zadejte validní formát emailu',
      invitationSentMsg: 'Pozvánka byla poslána',
      userSettingsHeader: 'Nastavení uživatelů',
      nameEmailRoleColumn: 'Jméno, Email, Role',
      assignedProjectsColumn: 'Přiřazené projekty',
      employeesColumn: 'Lidé',
      resetPasswordDeleteUserLabel: 'Resetovat heslo, Smazat uživatele',
      roleLabel: 'Role',
      saveBtn: 'Uložit',
      allProjects: 'Všechny projekty',
      allEmployees: 'Všichni lidé',
      assignedEmployees: 'Lidé přiřazené k vyplňování',
      favoriteEmployee: 'Oblíbený člověk',
      noAssignedEmployees: '(žádní)',
      noFavoriteEmployee: '(žádný)',
      setFavoriteEmployeeBtn: 'Nastavit',
      assignProjectBtn: 'Přiřadit',
      unassignProjectBtn: 'Odebrat',
      assignEmployeeBtn: 'Přiřadit',
      resetBtn: 'Resetovat',
      deleteBtn: 'Smazat',
    },
    cashFlowPage: {
      title: '{projectName}: Finance',
      companyOverview: 'Přehled projektu',
      previousMonth: 'Předchozí měsíc',
      nextMonth: 'Následující měsíc',
      showDeletedItems: 'Ukaž smazané',
      showHiddenItems: 'Ukaž schované',
      hideDeletedItems: 'Schovej smazané',
      hideItems: 'Schovej položky',
      months: {
        '01': 'Leden',
        '02': 'Únor',
        '03': 'Březen',
        '04': 'Duben',
        '05': 'Květen',
        '06': 'Červen',
        '07': 'Červenec',
        '08': 'Srpen',
        '09': 'Září',
        '10': 'Říjen',
        '11': 'Listopad',
        '12': 'Prosinec',
      },
      categories: {
        'saldo-cumulative': 'Saldo kumulativně',
        'saldo-forecast-cumulative': 'Saldo kumulativně s forecastem',
        'forecast-cumulative': 'Forecast kumulativně',
        forecast: 'Forecast',
        'saldo-internal': 'Saldo interních projektů',
        saldo: 'Saldo',
        income: 'Příjmy',
        expense: 'Výdaje',
        'vat-estimate': 'DPH odhad',
        'vat-reality': 'DPH realita',
        1: 'Výdaje',
        2: 'Příjmy',
        3: 'Forecast výdajů',
        4: 'Forecast příjmů',
        5: 'Lidé',
        6: 'Interní projekty',
      },
      defaultCapacityDialog: {
        title({ values: { employee } }) {
          return `Defaultní kapacita${employee ? ' pro ' + employee.name : ''}`;
        },
        submitBtn: 'Submit',
      },
      vatSelectDialog: {
        editTitle: 'Upravit výše daní',
        selectTitle: 'Vybrat výši daně',
        noneLabel: 'Žádná',
      },
      aggregation: {
        sum: 'Součet',
        average: 'Průměr',
        min: 'Minimum',
        max: 'Maximum',
        count: 'Počet',
      },
    },
    capacitiesPage: {
      title: '{projectName}: Kapacity',
      weekTitle: 'Týden {weekNumber}',
      projectsHeader: 'Projekty',
      previousWeek: 'Předchozí týden',
      nextWeek: 'Následující týden',
      employee: 'Člověk',
      capacity: 'Kapacita',
      utilization: 'Utilizace',
      workingHours: 'Dostupná kapacita',
      plan: 'Plán',
      fact: 'Realita',
      addNewEmployee: 'Přidat člověka',
      addNewProject: 'Přidat projekt',
      assignProject: 'Přiřadit projekt',
      assignInternalProject: 'Přiřadit interní projekt',
      showDeletedItems: 'Ukaž smazané',
      showHiddenItems: 'Ukaž schované',
      hideDeletedItems: 'Schovej smazané',
      hideItems: 'Schovej položky',
    },
    employeesPage: {
      title: '{projectName}: Lidé',
      employeesHeader: 'Lidé',
      addNewEmployee: 'Přidat člověka',
      previousWeek: 'Předchozí týden',
      nextWeek: 'Následující týden',
      weeksLabel: 'Týden {start} - {end}',
      weekTitle: 'Týden {weekNumber}',
      plan: 'Plán',
      fact: 'Realita',
      capacity: 'Kap',
      noAssignedProjects: 'Tento člověk nemá přiřazené žádné projekty.',
      assignProject: 'Přiřadit projekt',
      assignProjectTo: 'Přiřadit projekt k {employeeName}',
    },
    projectsPage: {
      title: '{projectName}: Projekty',
      projectsHeader: 'Projekty',
      addNewProject: 'Přidat nový projekt',
      previousWeek: 'Předchozí týden',
      nextWeek: 'Následující týden',
      weeksLabel: 'Týden {start} - {end}',
      weekTitle: 'Týden {weekNumber}',
      plan: 'Plán',
      fact: 'Realita',
    },
    timesheetsPage: {
      title: '{projectName}: Timesheet',
      selectPerson: 'Vybrat člověka',
      weekTitle: 'Týden {weekNumber}',
      projectsHeader: 'Projekty',
      previousWeek: 'Předchozí týden',
      nextWeek: 'Následující týden',
      'calculated-plan': 'Plán',
      'calculated-fact': 'Realita',
      'calculated-capacity': 'Kapacita',
      'calculated-onload': 'Vytížení',
      assignProject: 'Přiřadit projekt',
      showHiddenItems: 'Ukaž schované',
      hideItems: 'Schovej položky',
      columnHeader: ({ values: { columnId } }) => {
        if (columnId === 'total-plan') {
          return 'TOTAL PLÁN';
        }
        if (columnId === 'total-fact') {
          return 'TOTAL REALITA';
        }
        const date = new Date(columnId);
        const [, m, d] = columnId.split('-');
        const dayNum = date.getDay();
        const days = ['Neděle', 'Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota'];
        return `${days[dayNum]} ${d}. ${m}.`;
      },
    },
    workReportsPage: {
      title: '{projectName}: Výkazy práce',
      workReportsHeader: 'Výkazy práce',
      projectColumn: 'Projekt',
      employeeColumn: 'Člověk',
      dateColumn: 'Datum',
      invoiceColumn: 'Faktura',
      noteColumn: 'Poznámka',
      hoursColumn: 'Hodiny',
      yesNoBoolean: {
        1: 'Ano',
        0: 'Ne',
        null: '-',
      },
      csvExportBtn: 'CSV Export',
      saveRow: 'Uložit',
      discardRow: 'Zahodit změny',
      resetRow: 'Vynulovat',
      deleteNewRow: 'Smazat',
      newWorkReport: 'Nový výkaz práce',
      itemsPerPage: 'Řádků na stránku',
      forceUpdateDialog: {
        title:
          'Výkaz práce pro daného člověka, projekt a den se zadaným časem, poznámkou nebo fakturou už existuje. Chcete ho přepsat?',
        overwriteBtn: 'Přepsat',
        cancelBtn: 'Zrušit',
      },
      assignProject: 'Přiřadit projekt',
    },
  },
};
